import React, { useContext } from 'react';
import { useState } from 'react';
import { ContextProvider } from '../Context/SharedStateContext';
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import Footer from '../../Epic-X/Components/Footer';
import Header from '../../Epic-X/Components/Header';

const ReviewPrice = () => {
  const navigate = useNavigate();
  const { setPlanSelected, setPlanTypeSelected } = useContext(ContextProvider);
  const [isYearly, setIsYearly] = useState(false);

  const togglePricing = () => {
    setIsYearly(!isYearly);
  };

  const pricingPlans = [
    {
      title: "Free",
      description: "Best for personal use",
      monthlyPrice: "$0",
      yearlyPrice: "$0",
      features: [
        "100 Review Request- Emails",
        "25 Product Reviews"
      ],
      planName: "free"
    },
    {
      title: "Growth",
      description: "Best for personal use",
      monthlyPrice: "$149",
      yearlyPrice: "$1499",
      features: [
        "Unlimited Review Request- Emails",
        "600 Product Reviews",
        "100 Site Reviews",
        "50 Picture Reviews",
        "Google Rich Snippets"
      ],
      planName: "growth"
    },
    {
      title: "Professional",
      description: "Best for personal use",
      monthlyPrice: "$249",
      yearlyPrice: "$2499",
      features: [
        "Unlimited Review Request- Email",
        "1,000 Product Reviews",
        "500 Site Reviews",
        "250 Picture Reviews",
        "Review Grouping",
        "Google Rich Snippets",
        "Google Shopping Ads",
        "Rewards Integration"
      ],
      planName: "professional"
    },
    {
      title: "Premium",
      description: "Best for personal use",
      monthlyPrice: "$349",
      yearlyPrice: "$3499",
      features: [
        "Unlimited Review Request- Emails",
        "3,000 Product Reviews",
        "1,000 Site Reviews",
        "500 Picture Reviews",
        "Review Grouping",
        "Instagram Curation",
        "Photo Gallery",
        "Google Rich Snippets",
        "Google Shopping Ads",
        "Rewards Integration",
        "Walmart Syndication"
      ],
      planName: "premium"
    },
    {
      title: "Enterprise",
      description: "Best for personal use",
      monthlyPrice: "$Lets talk",
      yearlyPrice: "$Lets talk",
      features: [
        "Unlimited Review Request- Emails",
        "Unlimited Product Reviews",
        "Unlimited Site Reviews",
        "Unlimited Picture Reviews",
        "Google Rich Snippets",
        "Google Shopping Ads",
        "Rewards Integration"
      ],
      planName: "enterprise"
    }
  ];

  function handleGetStarted(plans) {
    const product = 'review';
    let pricingType = '';
    if (plans === 'free') {
      pricingType = 'both';
    } else {
      pricingType = isYearly ? 'year' : 'month';
    }
    setPlanSelected(plans);
    setPlanTypeSelected(pricingType);
    navigate(`/Register?product=${product}&plan=${plans}&type=${pricingType}`);
  };

  return (
    <div>
      {/* Header Start */}
      <Header />
      <div className="container-fluid bg-breadcrumb">
        <div className="container text-center py-5" style={{ maxWidth: '900px' }}>
          <h4 className="text-white display-4 mb-4 wow fadeInDown" data-wow-delay="0.1s">Pricing</h4>
          <ol className="breadcrumb d-flex justify-content-center mb-0 wow fadeInDown" data-wow-delay="0.3s">
            <li className="breadcrumb-item">
              <Link to={"/"}>Home</Link>
            </li>
            <li className="breadcrumb-item active text-primary">Pricing</li>
          </ol>
        </div>
      </div>
      {/* Header End */}

      {/* Pricing Section Start */}
      <div className="container-fluid py-5">
        <div className="epic-x-pricing-container">
          <div className="text-center">
            <h2 className="epic-x-heading">Streamline your teamwork. Start free.</h2>
            <p className="epic-x-subheading">Choose the perfect plan for your business needs</p>
          </div>
          <div className="epic-x-toggle-container">
            <span className="epic-x-toggle-label">Pay Monthly</span>
            <label className="epic-x-switch">
              <input type="checkbox" id="toggle" checked={isYearly} onChange={togglePricing} />
              <span className="epic-x-slider epic-x-round"></span>
            </label>
            <span className="epic-x-toggle-label">Pay Yearly</span>
          </div>
          <div className="epic-x-pricing-plans">
            {pricingPlans.map((plan, index) => (
              <div
                key={index}
                className={`epic-x-plan`}
              >
                <h3 className="epic-x-plan-title">{plan.title}</h3>
                <p className="epic-x-plan-description">{plan.description}</p>
                <p className="epic-x-price">
                  {isYearly ? plan.yearlyPrice : plan.monthlyPrice}{" "}
                  <span className="epic-x-price-duration">/ {isYearly ? "Year" : "Month"}</span>
                </p>
                <button 
                  className="epic-x-button" 
                  onClick={() => plan.title !== "Enterprise" ? handleGetStarted(plan.planName) : null}
                >
                  Get Started Now
                </button>
                <h6 className="epic-x-features-title">
                  {index === 0 ? "What you get:" : 
                   `All ${index === 1 ? "free" : index === 2 ? "Growth" : index === 3 ? "Professional" : "Premium"} features, plus:`}
                </h6>
                <ul className="epic-x-features">
                  {plan.features.map((feature, i) => (
                    <li
                      key={i}
                      className="epic-x-feature"
                    >
                      {feature}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </div>
      {/* Pricing Section End */}
      <Footer />
    </div>
  );
};

export default ReviewPrice;